function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.85 8L13 6.853 6.5.374 0 6.854 1.15 8 6.5 2.668 11.85 8z",
  fill: "#000"
});

function SvgUpChevronDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "15ffad3a3a1702138a84e7d507d1ec6a.svg";
export { SvgUpChevronDark as ReactComponent };